const EntityStatus = Object.freeze({
    ENABLED: 'ENABLED',
    DELETED: 'DELETED',
});

export { EntityStatus };